module.exports = __webpack_public_path__ + "static/media/packageLoader.c97e3340.gif";